/**
 *
 * StatusFilter
 *
 */
import { StatusPicker } from 'app/components/pickers/AutocompletePickers/StatusPicker';
import * as React from 'react';
import { translations } from 'locales/translations';
import { useTranslation } from 'react-i18next';
import { Entity } from 'types/common';
import { IFilterComponentProps } from '../IFilterComponentProps';

export const StatusFilter = (props: IFilterComponentProps) => {
  const handleOnChange = (value: Entity<number> | null) => {
    props.onChange(value);
  };
  const { t } = useTranslation();
  return (
    <StatusPicker
      value={props.value as Entity<number> | undefined}
      onChange={handleOnChange}
      isOpen={props.open}
      size="small"
      placeholder={t(translations.AllValues)}
      ariaLabel={props.label}
      id={props.id}
    />
  );
};
export default StatusFilter;
